import { shouldPolyfill } from '@formatjs/intl-pluralrules/should-polyfill';

(async () => {
  if (shouldPolyfill()) {
    await import('@formatjs/intl-pluralrules/polyfill');
  }

  if (Intl.PluralRules.polyfilled) {
    // TODO: Work out how to determine the language; default to 'en' for now.
    await import('@formatjs/intl-pluralrules/locale-data/en');
  }
})();
